import { Component, Input } from '@angular/core';
import { GlobalVariables } from '../../variables/global';
import { Nav } from 'ionic-angular';
import { camelCase } from 'lodash';

@Component({
  selector: 'dev-breadcrumbs',
  templateUrl: 'dev-breadcrumbs.html',
})
export class DevBreadcrumbsComponent {
  public isChildPage: string;

  @Input('path') _path: Array<string>;

  constructor(public nav: Nav) { }

  get listOfViews() {
    return (this._path) ? this._path : this.getTreeViewsByURL(window.location.hash);
  }

  getTitleOfView(view_id) {
    return GlobalVariables.pages[view_id].text
  }

  getTreeViewsByURL(url): Array<string> {
    let treeOfViews = [];
    const currentPage = this.nav.getActive().id;
    const currentKey = camelCase(currentPage);
    //default page
    treeOfViews.push('home');

    if (GlobalVariables.pages.hasOwnProperty(currentKey)) {
      treeOfViews.push(currentKey)
    }

    // Dont delete if you arent sure that this code not will use.
    // This code create a treeOfViews with current url
    /*
    url.split('/').forEach(viewID => {
      const viewKey = camelCase(viewID);
      if (GlobalVariables.pages.hasOwnProperty(viewKey)) {
        treeOfViews.push(viewKey)
      }
    });*/


    return treeOfViews;
  }

  popTo(indexPage: number, viewKey: string) {
    // TODO if possible, find a better way to navigate to pages
    const link = GlobalVariables.pages[viewKey].link;

    this.nav.push(link)
  }
}



// WEBPACK FOOTER //
// ./src/components/dev-breadcrumbs/dev-breadcrumbs.ts